export const generateRandomUid = () => {
	const randomNumber = Math.floor(Math.random() * 100000).toString()
	const randomLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26))
	const uid = `${randomLetter}${randomNumber}`
	return uid
}
